import { atom, useAtom } from "jotai"
import { useCallback, useEffect, useMemo } from "react"

const searchAtom = atom(false)

export const useSearchActions = () => {
  const [isOpen, setIsOpen] = useAtom(searchAtom)

  const toggleSearch = useCallback(() => {
    setIsOpen((s) => !s)
  }, [setIsOpen])

  const closeSearch = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const openSearch = useCallback(() => {
    setIsOpen(true)
  }, [setIsOpen])

  return useMemo(
    () => ({
      isOpen,
      closeSearch,
      toggleSearch,
      openSearch,
    }),
    [openSearch, isOpen, closeSearch, toggleSearch]
  )
}

export function useAttachGlobalSearchKeyboardShortcut(onToggle: () => void) {
  useEffect(() => {
    // open search with cmd+k key press
    const callback = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault()
        e.stopPropagation()
        onToggle()
      }
    }

    window.addEventListener("keydown", callback, { capture: true })
    return () => {
      window.removeEventListener("keydown", callback, { capture: true })
    }
  }, [onToggle])
}
